import react from "react";
import axios from '../../axios/axiosconf'
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { generarPdfConTextoNativo } from "../../../utils/pdfHelpers";
import { Modal, Button } from "react-bootstrap";

function ModalIncapacidades(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');
    const [timelineItemSeleccionadoId, setTimelineItemSeleccionadoId] = useState(null);

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [incapacidadSeleccionada, setIncapacidadSeleccionada] = useState(null);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false); // 🆕 Modal post-guardado
    const idIncapacidadGuardadaRef = useRef(null);

    // 🎯 ESTADOS PARA ACORDEONES REACT
    const [acordeonFechaHora, setAcordeonFechaHora] = useState(true);
    const [acordeonContenido, setAcordeonContenido] = useState(true);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-incapacidades', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            })

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return { nombreCompleto: 'Paciente no identificado', documentoCompleto: '—' };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    /** Una incapacidad: banner → FECHA/PROF. → cuerpo → firma (mismo orden que PDF por ítem). */
    const construirHtmlCuerpoIncapacidadItem = (incapacidad) => {
        const profTrat = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado'
            ? incapacidad.profesional_tratante_completo
            : 'No registrado';

        const banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    INCAPACIDAD MÉDICA
                </div>
            </div>`;

        const tablaFechaProf = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${incapacidad.fecha || ''}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${profTrat}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const cuerpoHtml = incapacidad.contenido
            ? incapacidad.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        const bloqueIncapacidad = `
            <div style="margin-bottom: 12px;">
                <div style="font-size: 11px; font-weight: bold; color: #325e68; margin-bottom: 8px; letter-spacing: 0.02em;">INCAPACIDAD</div>
                <div style="border: 1px solid #dee2e6; border-radius: 2px; padding: 12px; background: #ffffff; font-size: 13px; line-height: 1.45;">
                    ${cuerpoHtml}
                </div>
            </div>`;

        const tieneProf = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado';
        let bloqueFirma = '';
        if (tieneProf && incapacidad.profesional && incapacidad.firma) {
            bloqueFirma = `
                <div style="margin-top: 8px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6; vertical-align: top;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                    <img src="${incapacidad.firma}" alt="Firma" style="max-width: 180px; max-height: 90px; display: block;" />
                                    <div style="margin-top: 8px; font-size: 12px; color: #6c757d;">
                                        ${incapacidad.profesional}<br/>
                                        <strong>RM:</strong> ${incapacidad.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${incapacidad.codigo_habilitacion || 'N/A'}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        return banner + tablaFechaProf + bloqueIncapacidad + bloqueFirma;
    };

    /** Vista modal “Ver todo”: encabezado opcional → PACIENTE/DOCUMENTO una vez → título → cada ítem como en el PDF. */
    const construirHtmlConsolidadoIncapacidades = (items) => {
        if (!items || items.length === 0) {
            return '';
        }
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const tablaPacienteDoc = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;
        const titulo = '<h1 style="text-align: center; margin-bottom: 16px; font-size: 1.25rem; color: #323a45;">INCAPACIDADES</h1>';
        let bloques = '';
        items.forEach((item, i) => {
            if (i > 0) {
                bloques += '<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;" />';
            }
            bloques += `<div style="page-break-inside: avoid;">${construirHtmlCuerpoIncapacidadItem(item)}</div>`;
        });
        return encabezadoPrev +
            '<div class="consolidado-incapacidades-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            tablaPacienteDoc +
            titulo +
            bloques +
            '</div>';
    };

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/incapacidades', config2)
            .then(response => {
                console.log('Respuesta incapacidades:', response.data);
                setHistorial(response.data);
                setConsolidado(construirHtmlConsolidadoIncapacidades(response.data || []));
            })
            .catch(error => {
                console.log('Error cargando incapacidades:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }



    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
        setErrorlist((prev) => {
            if (!prev.contenido) return prev;
            const next = { ...prev };
            delete next.contenido;
            return next;
        });
    };




    const establecerFechaHoraActual = () => {
        const ahora = new Date();
        const fechaFormateada = ahora.toISOString().slice(0, 16);
        setFechaHora(fechaFormateada);
    };

    const textoPlanoDesdeHtml = (html) => {
        if (!html || typeof html !== 'string') return '';
        const tmp = typeof document !== 'undefined' ? document.createElement('div') : null;
        if (tmp) {
            tmp.innerHTML = html;
            return (tmp.textContent || tmp.innerText || '').replace(/\u00a0/g, ' ');
        }
        return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ');
    };

    const contenidoIncapacidadVacio = (html) => {
        return textoPlanoDesdeHtml(html).trim().length === 0;
    };

    const formatearMensajesError = (valor) => {
        if (valor == null) return '';
        if (Array.isArray(valor)) return valor.join(' ');
        return String(valor);
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const erroresCliente = {};

        if (!fechaHora || String(fechaHora).trim() === '') {
            erroresCliente.hora_inicial = ['Indique la fecha y hora de la incapacidad.'];
        }

        if (contenidoIncapacidadVacio(contenido)) {
            erroresCliente.contenido = ['El contenido de la incapacidad es obligatorio.'];
        }

        if (!client || client.client_id == null || client.client_id === '') {
            erroresCliente.general = ['No se cargó la información del cliente. Recargue la página o intente más tarde.'];
        }

        if (Object.keys(erroresCliente).length > 0) {
            setErrorlist(erroresCliente);
            if (erroresCliente.hora_inicial) setAcordeonFechaHora(true);
            if (erroresCliente.contenido) setAcordeonContenido(true);
            return;
        }

        setErrorlist({});

        // 🆕 PROFESIONAL INDEPENDIENTE - Verificar si debe validar acceso (con fallback)
        let esProfesionalIndependiente = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            esProfesionalIndependiente = userdata.permissions.some(permission => permission.slug === 'profesionalIndependiente');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('profesionalIndependiente')) {
            esProfesionalIndependiente = true;
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            paciente_id: pacienteId,
            client_id: client.client_id,
            users_id: userdata.user_id, // 🆕 Agregar users_id para profesional tratante
            profesional: nombreProfesional,
            firma: firmaimg,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config.validar_asignacion = true;
        }

        setLoading(true);

        axios.post('/incapacidad', config)
            .then(response => {
                console.log('Incapacidad guardada exitosamente:', response.data);
                const resp = response.data;
                const nuevoId = resp && (resp.id ?? resp.incapacidad_id ?? (resp.data && resp.data.id));
                idIncapacidadGuardadaRef.current = nuevoId != null ? nuevoId : null;

                setLoading(false);
                setContenido('');
                setFechaHora('');
                if (document.getElementById('plantillas')) {
                    document.getElementById('plantillas').value = "";
                }
                setDeshabilitarBotonGuardar(true);
                cargaritems();
                setErrorlist({});

                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                console.log('Error guardando incapacidad:', error);
                const data = error.response && error.response.data ? error.response.data : null;

                if (data && data.errors && typeof data.errors === 'object') {
                    setErrorlist(data.errors);
                    const errs = data.errors;
                    if (errs.hora_inicial || errs.fecha || errs.hora) setAcordeonFechaHora(true);
                    if (errs.contenido) setAcordeonContenido(true);
                } else {
                    setErrorlist({});
                    const msg = (data && (data.message || data.error)) || error.message || 'No se pudo guardar la incapacidad.';
                    alert(msg);
                }
            })
    }

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const rellenarSeccionesPdfIncapacidadItem = (secciones, incapacidad) => {
        secciones.push({
            tipo: 'banner',
            titulo: 'INCAPACIDAD MÉDICA',
            contenido: 'INCAPACIDAD MÉDICA'
        });

        const profTrat = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado'
            ? incapacidad.profesional_tratante_completo
            : 'No registrado';

        secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'FECHA Y HORA', valor: String(incapacidad.fecha || '') },
                    { etiqueta: 'PROFESIONAL TRATANTE', valor: profTrat }
                ]
            }
        });

        secciones.push({
            tipo: 'texto',
            titulo: 'INCAPACIDAD',
            contenido: incapacidad.contenido || ''
        });

        const tieneProf = incapacidad.profesional_tratante_completo &&
            incapacidad.profesional_tratante_completo !== 'No registrado';
        if (tieneProf && incapacidad.profesional && incapacidad.firma) {
            secciones.push({
                tipo: 'firma',
                imagenBase64: incapacidad.firma,
                metadata: {
                    tipo: 'profesional',
                    nombre: incapacidad.profesional || '',
                    registroMedico: incapacidad.registro_medico || 'N/A',
                    codigoHabilitacion: incapacidad.codigo_habilitacion || 'N/A'
                }
            });
        }
    };

    /**
     * PDF nativo — ítem único. PACIENTE/DOCUMENTO los añade el helper.
     */
    const construirConfigPdfIncapacidadNativo = (incapacidad) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `incapacidad-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };

        rellenarSeccionesPdfIncapacidadItem(config.secciones, incapacidad);
        return config;
    };

    /**
     * PDF nativo — historial completo (una página nueva por ítem tras el primero).
     */
    const construirConfigPdfIncapacidadesConsolidadoNativo = () => {
        if (!historial || historial.length === 0) {
            return null;
        }
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `incapacidades-consolidado-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };

        config.secciones.push({
            tipo: 'banner',
            titulo: 'INCAPACIDADES',
            contenido: 'INCAPACIDADES'
        });

        historial.forEach((item, index) => {
            if (index > 0) {
                config.secciones.push({ tipo: 'salto-pagina' });
            }
            rellenarSeccionesPdfIncapacidadItem(config.secciones, item);
        });

        return config;
    };

    /**
     * Vista previa ítem: encabezado opcional → PACIENTE/DOCUMENTO → mismo cuerpo que `construirHtmlCuerpoIncapacidadItem`.
     */
    const construirHtmlVistaIncapacidadNativa = (incapacidad) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const encabezadoPrev = encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? generarEncabezadoHTML()
            : '';
        const tablaPacienteDoc = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 28%; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        return encabezadoPrev +
            '<div class="vista-incapacidad-pdf-paridad" style="font-family: sans-serif; color: #212529;">' +
            tablaPacienteDoc +
            construirHtmlCuerpoIncapacidadItem(incapacidad) +
            '</div>';
    };

    const verIncapacidad = (incapacidad) => {
        setTituloResumen('Incapacidad Médica - Vista Previa');
        setIncapacidadSeleccionada(incapacidad);
        setTimelineItemSeleccionadoId(incapacidad.id);
        setContenidoResumenIndividual(construirHtmlVistaIncapacidadNativa(incapacidad));
        setShowModalResumen(true);
    };

    /**
     * Limpia el formulario para un registro nuevo.
     * @param {number|string|null} preservarTimelineId - Si se indica, mantiene resaltado ese ítem en el historial.
     */
    const nuevaIncapacidad = (preservarTimelineId = null) => {
        setIncapacidadSeleccionada(null);
        setTimelineItemSeleccionadoId(preservarTimelineId != null ? preservarTimelineId : null);
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setContenido('');

        setAcordeonFechaHora(true);
        setAcordeonContenido(true);

        // Limpiar formulario
        if (document.getElementById('plantillas')) {
            document.getElementById('plantillas').value = "";
        }
    };

    const descargarPdfIncapacidad = async () => {
        if (!incapacidadSeleccionada) return;

        try {
            const config = construirConfigPdfIncapacidadNativo(incapacidadSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            const name = config.filename || 'incapacidad-' + (props.docPaciente || 'paciente') + '.pdf';
            pdf.save(name);
        } catch (err) {
            console.error('PDF nativo incapacidad (descarga):', err);
            alert('No se pudo generar el PDF. Intente de nuevo.');
        }
    };

    const descargarPdfConsolidado = async () => {
        const config = construirConfigPdfIncapacidadesConsolidadoNativo();
        if (!config) {
            alert('No hay incapacidades en el historial para exportar.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            pdf.save(config.filename || 'incapacidades-consolidado.pdf');
        } catch (err) {
            console.error('PDF nativo consolidado incapacidades:', err);
            alert('No se pudo generar el PDF consolidado. Intente de nuevo.');
        }
    };

    const imprimirPdfConsolidado = async () => {
        const config = construirConfigPdfIncapacidadesConsolidadoNativo();
        if (!config) {
            alert('No hay incapacidades en el historial para imprimir.');
            return;
        }
        try {
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');
            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                window.open(url, '_blank');
            }
        } catch (err) {
            console.error('Imprimir PDF nativo consolidado:', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    // Imprimir incapacidad (PDF nativo; foliación incluida en generarPdfConTextoNativo)
    const imprimirIncapacidad = async () => {
        if (!incapacidadSeleccionada) {
            alert('No hay incapacidad seleccionada para imprimir');
            return;
        }

        try {
            const config = construirConfigPdfIncapacidadNativo(incapacidadSeleccionada);
            const pdf = await generarPdfConTextoNativo(config);
            const blob = pdf.output('blob');
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');

            if (printWindow) {
                printWindow.onload = function () {
                    setTimeout(() => printWindow.print(), 500);
                };
            } else {
                const iframe = document.createElement('iframe');
                iframe.style.position = 'fixed';
                iframe.style.right = '0';
                iframe.style.bottom = '0';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);

                iframe.onload = function () {
                    setTimeout(() => {
                        try {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();
                            setTimeout(() => {
                                document.body.removeChild(iframe);
                                URL.revokeObjectURL(url);
                            }, 1000);
                        } catch (e) {
                            console.error('Error al imprimir:', e);
                            alert('No se pudo abrir el diálogo de impresión. Descargue el PDF e imprímalo desde su visor.');
                            document.body.removeChild(iframe);
                            URL.revokeObjectURL(url);
                        }
                    }, 500);
                };
            }
        } catch (err) {
            console.error('PDF nativo incapacidad (imprimir):', err);
            alert('No se pudo generar el PDF para imprimir.');
        }
    };

    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        let idSel = idIncapacidadGuardadaRef.current;
        idIncapacidadGuardadaRef.current = null;
        if (idSel == null && historial && historial.length > 0) {
            idSel = historial[0].id;
        }
        nuevaIncapacidad(idSel);
        // No guardarCambios(msg): evita toast duplicado; el modal ya informa el éxito y cargaritems() ya corrió al guardar.
    };

    useEffect(() => {
        cargaritems();

        // Cleanup para evitar memory leaks
        return () => {
            // Cancelar cualquier request pendiente si es necesario
        };
    }, [props.cargarHistorial]);


    const descargarPdf = () => {
        var opt = {
            margin: 10,
            filename: `incapacidades.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                letterRendering: true,
                scrollY: 0
            },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        let anamnesis = props.anamnesis();
        let incapacidadesCompleta = "<img src='" + logoImg + "' class='app-logo-pdf' /><h1 class='ttl-pdf'>INCAPACIDADES</h1>" + anamnesis + "<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(incapacidadesCompleta, opt);
    };


    if (loggedIn) {
        return (

            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <div className="mb-3 pb-2 border-bottom">
                                    <small className="text-muted">
                                        Seleccione una fecha en el historial para abrir la vista previa e imprimir o descargar ese registro.
                                    </small>
                                </div>

                                {errorlist.general && (
                                    <div className="alert alert-warning py-2 px-3 mb-3" role="alert">
                                        {formatearMensajesError(errorlist.general)}
                                    </div>
                                )}

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="row">
                                            {/* 🆕 PROFESIONAL TRATANTE - Siempre visible */}
                                            <div className="col-md-12">
                                                <div className="card" style={{ marginBottom: '15px' }}>
                                                    <div className="card-body" style={{ padding: '15px' }}>
                                                        <div className="form-group" style={{ marginBottom: '0' }}>
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza la incapacidad</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonFechaHora(!acordeonFechaHora)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100 mb-0">
                                                            <span className="d-block w-100">Fecha y Hora <span className="text-danger">*</span></span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonFechaHora ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <div className="form-group">
                                                            <label>Fecha y Hora <span className="text-danger">*</span></label>
                                                            <div className="input-group">
                                                                <input
                                                                    type="datetime-local"
                                                                    className={'form-control' + (errorlist.hora_inicial ? ' is-invalid' : '')}
                                                                    required
                                                                    value={fechaHora}
                                                                    onChange={(e) => {
                                                                        setFechaHora(e.target.value);
                                                                        setErrorlist((prev) => {
                                                                            if (!prev.hora_inicial) return prev;
                                                                            const next = { ...prev };
                                                                            delete next.hora_inicial;
                                                                            return next;
                                                                        });
                                                                    }}
                                                                />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            {errorlist.hora_inicial && (
                                                                <div className="invalid-feedback d-block">
                                                                    {formatearMensajesError(errorlist.hora_inicial)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" onClick={() => setAcordeonContenido(!acordeonContenido)} style={{ cursor: 'pointer' }}>
                                                        <h4 className="card-title w-100 mb-0">
                                                            <span className="d-block w-100">Contenido de la Incapacidad <span className="text-danger">*</span></span>
                                                        </h4>
                                                    </div>
                                                    <div className={acordeonContenido ? '' : 'collapse'} style={{ padding: '20px' }}>
                                                        <label style={{ fontSize: '1rem', marginBottom: '8px' }}>Seleccione la incapacidad o digite su contenido <span className="text-danger">*</span></label>
                                                        <div className="form-group">
                                                            <select name="plantillas" className="form-control" id="plantillas" onChange={(e) => setContenido(e.target.value)} >
                                                                <option></option>
                                                                {
                                                                    plantillas.map((plantilla, index) =>
                                                                        <option key={index} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                        </div>
                                                        {errorlist.contenido && (
                                                            <div className="invalid-feedback d-block">
                                                                {formatearMensajesError(errorlist.contenido)}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label htmlFor="nombreProfesional">Firma</label>
                                                            <br></br>
                                                            <img src={firmaimg} className="firma-profesional-hc" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>


                                </form>


                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de incapacidades</b>

                                    {
                                        historial.map((item) =>

                                            <div
                                                className="timeline-item-container"
                                                key={item.id}
                                                onClick={() => verIncapacidad(item)}
                                                style={{
                                                    cursor: 'pointer',
                                                    ...(timelineItemSeleccionadoId != null && String(timelineItemSeleccionadoId) === String(item.id)
                                                        ? { backgroundColor: 'rgba(23, 162, 184, 0.12)', borderRadius: '8px', padding: '4px 6px' }
                                                        : {})
                                                }}
                                            >
                                                <div className="timeline-punto-container"><div className="timeline-punto" style={timelineItemSeleccionadoId != null && String(timelineItemSeleccionadoId) === String(item.id) ? { backgroundColor: '#17a2b8', borderColor: '#17a2b8' } : undefined}></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-outline-secondary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Ver todo</button>

                            </div>
                        </div>
                    </div>
                </section>

                <Modal show={showModalResumen} onHide={() => setShowModalResumen(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>{tituloResumen}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: '0.5rem' }}>
                        <div className="resumen-historico" dangerouslySetInnerHTML={{ __html: contenidoResumenIndividual }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" size="sm" onClick={imprimirIncapacidad}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={descargarPdfIncapacidad}>
                            <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={() => setShowModalResumen(false)}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConsolidado} onHide={() => setShowModalConsolidado(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>Resumen incapacidades</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: '0.5rem' }}>
                        <div className="resumen-historico" dangerouslySetInnerHTML={{ __html: consolidado }} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" size="sm" onClick={imprimirPdfConsolidado}>
                            <i className="fas fa-print mr-1"></i> Imprimir
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={descargarPdfConsolidado}>
                            <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                        </Button>
                        <Button variant="secondary" size="sm" onClick={() => setShowModalConsolidado(false)}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-medical mr-1"></i> Incapacidad guardada
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            La incapacidad ha sido guardada exitosamente. Puede abrirla desde el historial para vista previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>

        );
    }

    return (
        <Loading />
    );
}
export default ModalIncapacidades;